export interface ArticleData {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  date: string;
  readCount: number;
  commentCount: number;
  author: string;
  imageSeq: string;
}

export const allArticles: ArticleData[] = [
  {
    id: "article-1",
    title: "新人必读：爱情岛论坛完整使用攻略与注意事项",
    excerpt: "本文为刚加入爱情岛论坛的新用户梳理了从注册到熟练使用的全部流程，包括账号设置、板块选择、发帖技巧以及社区规范等重要内容。",
    content: "欢迎来到爱情岛论坛！作为新成员，了解论坛的基本操作和社区规范非常重要。首先，注册账号后建议立即完善个人资料，包括头像、昵称和个人简介，这有助于其他用户更好地认识你。\n\n浏览板块时，可以根据兴趣选择情感交流、生活分享、技术讨论等不同分类。每个板块下还有细分话题标签，方便精准定位感兴趣的内容。\n\n发帖时请注意标题简洁明了、内容充实有料，避免纯表情或水帖。回复他人帖子时保持友善和尊重，优质回复往往能收获更多互动。\n\n论坛设有积分和等级系统，积极参与讨论、发布优质内容即可快速升级。高级用户享有更多功能权限。\n\n最后，请务必阅读并遵守《爱情岛社区管理规范》，共同维护温暖有爱的交流环境。如有任何疑问，随时联系在线客服。",
    category: "使用攻略",
    categorySlug: "shiyong-gonglve",
    date: "2026-08-01",
    readCount: 52890,
    commentCount: 1236,
    author: "岛主小助手",
    imageSeq: "hot-article-01",
  },
  {
    id: "article-2",
    title: "如何在爱情岛论坛找到志同道合的朋友？",
    excerpt: "在偌大的社区中找到真正懂你的人并不容易。本文从兴趣匹配、板块选择、互动技巧等角度，分享在爱情岛论坛建立深度社交关系的方法。",
    content: "在爱情岛论坛这个庞大的社区中，如何找到真正与你合拍的朋友？这里分享几个实用技巧。\n\n首先，精准定位你的兴趣领域。爱情岛设有情感交流、生活分享、技术讨论、娱乐八卦、美食旅游、健康养生六大板块，选择最符合你兴趣的板块深耕。\n\n其次，善于使用搜索和标签功能。输入关键词查找你感兴趣的话题，关注活跃在该领域的优质用户，阅读他们的历史发帖，找到共同话题后主动互动。\n\n第三，在回复中展现真实的自己。真诚的交流和走心的分享比刻意的迎合更能打动人心。分享自己的故事和观点，让他人了解真实的你。\n\n第四，参与社区活动。爱情岛定期举办线上话题讨论、征文比赛等活动，这是结识新朋友的绝佳机会。\n\n最后，保持耐心和开放的心态。建立深厚的友谊需要时间，不要因为一时找不到知己而气馁。持续活跃、真诚交流，志同道合的朋友自然会出现。",
    category: "社区指南",
    categorySlug: "shequ-zhinan",
    date: "2026-07-28",
    readCount: 41230,
    commentCount: 987,
    author: "暖风徐徐",
    imageSeq: "hot-article-02",
  },
  {
    id: "article-3",
    title: "2026年爱情岛论坛最新功能更新全览",
    excerpt: "爱情岛论坛近期上线了多项重磅功能更新，包括全新UI界面、智能推荐算法、语音发帖等。本文为你逐一解读这些新功能的亮点与使用方法。",
    content: "2026年，爱情岛论坛迎来了一系列重大功能更新，用户体验全面升级。\n\n全新UI界面：我们对整体视觉进行了重新设计，采用更温暖柔和的色调体系，优化了信息层级和交互逻辑，浏览体验更加舒适流畅。\n\n智能推荐算法：基于你的浏览历史和互动偏好，系统会自动推荐你可能感兴趣的内容和用户，让发现优质内容变得更加轻松。\n\n语音发帖功能：不方便打字时，可以直接录制语音发布帖子，系统会自动生成文字版本供其他用户阅读。\n\n增强的隐私保护：新增帖子可见范围设置，你可以选择公开发布、仅好友可见或仅自己可见。私密相册功能也已上线。\n\n会员体系升级：VIP会员新增专属表情包、个性域名、优先客服等多项权益。\n\n多端同步优化：手机App与网页版之间的数据同步更快更稳定，切换设备时不会丢失任何消息。",
    category: "平台动态",
    categorySlug: "pingtai-dongtai",
    date: "2026-07-25",
    readCount: 38750,
    commentCount: 852,
    author: "科技观察员",
    imageSeq: "hot-article-03",
  },
  {
    id: "article-4",
    title: "爱情岛论坛账号安全防护指南",
    excerpt: "网络安全不容忽视！本文详细介绍了爱情岛论坛的账号保护机制，并提供了密码设置、二次验证、防钓鱼等实用安全建议。",
    content: "在享受社区交流乐趣的同时，账号安全绝对不能忽视。以下是在爱情岛论坛保护账号安全的全面指南。\n\n密码安全：请使用至少8位的复杂密码，包含大小写字母、数字和特殊符号。避免使用生日、手机号等容易被猜测的信息。建议每3个月更换一次密码。\n\n开启二次验证：在账号设置中启用手机短信或邮箱验证码登录，即使密码泄露，他人也无法登录你的账号。\n\n警惕钓鱼链接：不要点击来源不明的私信链接，官方通知只会通过站内信和认证邮箱发送。\n\n检查登录设备：定期在安全中心查看账号的登录设备记录，如发现异常登录立即修改密码并联系客服。\n\n绑定安全邮箱和手机：确保绑定的邮箱和手机号是你本人使用且可正常接收验证码的，这是找回账号的最后保障。\n\n公共设备注意事项：在网吧、图书馆等公共设备上登录论坛后，务必退出登录并清除浏览器缓存。",
    category: "使用攻略",
    categorySlug: "shiyong-gonglve",
    date: "2026-07-20",
    readCount: 29600,
    commentCount: 645,
    author: "安全卫士",
    imageSeq: "hot-article-04",
  },
  {
    id: "article-5",
    title: "情感交流板块精华帖合集：那些触动心灵的分享",
    excerpt: "我们精心整理了情感交流板块中获赞最高的50篇精华帖，涵盖恋爱关系、家庭相处、自我成长等话题，每一篇都值得细细品读。",
    content: "情感交流板块是爱情岛论坛最受欢迎的板块之一，这里汇聚了无数动人的故事和深刻的感悟。我们整理了近期最受欢迎的精华帖，与你分享。\n\n恋爱关系类：从初恋的懵懂到长久关系的经营，从异地恋的坚守到分手后的成长，每一段经历都是一堂生动的情感课。\n\n家庭相处类：与父母的沟通艺术、婆媳关系的微妙平衡、亲子教育的智慧分享，家庭永远是我们最温暖的港湾也是最需要用心经营的领域。\n\n自我成长类：如何建立自信、如何走出低谷、如何与自己和解——这些关于自我探索的帖子引发了最广泛的共鸣。\n\n友情与社交类：成年后如何维系友谊、职场人际关系的处理技巧、内向者在社交中的生存之道。\n\n每一篇精华帖都经过了社区用户的认可和版主的审核，质量有保证。如果你也在情感方面有困惑或感悟，欢迎在这个温暖的板块分享你的故事。",
    category: "情感交流",
    categorySlug: "qinggan-jiaoliu",
    date: "2026-07-15",
    readCount: 51200,
    commentCount: 1567,
    author: "知心姐姐",
    imageSeq: "hot-article-05",
  },
  {
    id: "article-6",
    title: "从零开始搭建你的爱情岛个人主页",
    excerpt: "想让你的个人主页更加个性化吗？本文手把手教你如何美化主页布局、设置头像封面、编辑个人简介，打造独一无二的社区形象。",
    content: "个人主页是你在爱情岛论坛的门面，一个精心打造的主页能让你在社区中脱颖而出。\n\n头像设置：选择一张清晰、有辨识度的头像照片，建议使用个人真实照片或具有代表性的个性化图片。圆形头像的尺寸建议在400x400像素以上。\n\n封面图片：封面是个人主页的视觉焦点，可以选择风景、艺术作品或自己拍摄的照片。爱情岛支持自定义封面，推荐尺寸为1200x400像素。\n\n个人简介：用简短的文字介绍自己，可以包括兴趣爱好、职业背景、个性签名等。好的简介能让访客快速了解你，建议控制在200字以内。\n\n内容展示：你可以选择置顶自己最满意的帖子，让访客第一时间看到你的优质内容。同时可以设置内容分类展示，方便访客按主题浏览。\n\n隐私设置：个人主页支持多种可见度设置，你可以选择完全公开、仅好友可见或自定义可见范围，灵活保护个人隐私。",
    category: "使用攻略",
    categorySlug: "shiyong-gonglve",
    date: "2026-07-10",
    readCount: 22450,
    commentCount: 478,
    author: "设计达人",
    imageSeq: "hot-article-06",
  },
  {
    id: "article-7",
    title: "美食旅游板块热门目的地推荐：2026年必去打卡地",
    excerpt: "根据社区用户的真实分享，整理出2026年最受欢迎的美食旅游目的地，从江南小镇到西北大漠，满足你的探索欲望。",
    content: "美食旅游板块的用户们用脚步丈量世界，用舌尖品味人生。以下是2026年社区讨论度最高的旅行目的地。\n\n江南水乡深度游：乌镇、西塘、周庄等古镇之外，绍兴安昌、湖州南浔等小众古镇开始受到追捧，原生态的水乡生活体验感满分。\n\n川西秘境探访：稻城亚丁、色达、四姑娘山，川西的壮美风光在社区中常年霸占旅行攻略热度榜。\n\n云南美食环线：从昆明的过桥米线到大理的乳扇，从丽江的腊排骨到西双版纳的傣味烧烤，一条美食环线吃遍云南。\n\n西北大环线：青海湖、敦煌、张掖丹霞，西北的辽阔与壮丽让每一位到访者都为之震撼。\n\n无论你是美食爱好者还是旅行达人，都可以在美食旅游板块找到志同道合的伙伴，一起规划下一次出发。",
    category: "美食旅游",
    categorySlug: "meishi-lvyou",
    date: "2026-07-08",
    readCount: 18760,
    commentCount: 534,
    author: "行走的味蕾",
    imageSeq: "hot-article-05",
  },
  {
    id: "article-8",
    title: "程序员专属：技术讨论板块精华资源汇总",
    excerpt: "技术讨论板块中隐藏着大量优质学习资源，本文汇总了前端开发、后端架构、AI应用等领域的高质量讨论帖和教程分享。",
    content: "爱情岛论坛的技术讨论板块虽然不是最大的板块，但内容质量极高。这里汇总了近期最值得关注的技术话题。\n\n前端开发趋势：React 19、Vue 4的新特性讨论热烈，Tailwind CSS和TypeScript已成为社区主流推荐的技术栈组合。\n\n后端架构探讨：微服务 vs 单体架构的争论仍在继续，Serverless和边缘计算正在改变传统后端开发模式。\n\nAI应用实战：大语言模型的本地部署、AI辅助编程的最佳实践、图像生成技术在日常项目中的应用，这些都是热门讨论话题。\n\n职业发展心得：从初级到资深工程师的成长路径、技术面试准备策略、远程办公经验分享，社区中的前辈们倾囊相授。\n\n开源项目推荐：不少社区成员在板块中分享了自己维护的开源项目，涵盖工具库、脚手架、学习资源等多个方向。",
    category: "技术讨论",
    categorySlug: "jishu-taolun",
    date: "2026-07-05",
    readCount: 15320,
    commentCount: 423,
    author: "代码诗人",
    imageSeq: "hot-article-06",
  },
  {
    id: "article-9",
    title: "健康养生板块：上班族的办公室微运动指南",
    excerpt: "长期久坐办公对身体健康的影响不容忽视。本文分享一套简单有效的办公室微运动方案，帮助上班族缓解颈椎腰椎疲劳。",
    content: "久坐是上班族健康的头号杀手。爱情岛论坛健康养生板块的达人们总结了一套在办公室就能完成的微运动方案。\n\n颈部放松：每隔1小时做一组颈部拉伸，包括左右侧屈、前后点头和缓慢旋转，每个动作保持15秒，有效缓解颈椎压力。\n\n肩部活动：耸肩、绕肩、肩胛骨夹紧，三个简单动作就能放松紧张的肩部肌肉。建议每2小时做一次。\n\n腰部保护：正确的坐姿是关键——臀部贴紧椅背、腰部有支撑、双脚平放地面。每隔45分钟起身活动3-5分钟。\n\n眼部保养：遵循20-20-20法则——每20分钟看20英尺（约6米）外的物体20秒，配合眼部按摩效果更佳。\n\n饮食建议：多喝水、少喝含糖饮料，办公桌常备坚果、水果等健康零食，避免高油高盐的外卖。\n\n养生是一个长期的过程，从小习惯开始改变，健康自然会随之而来。",
    category: "健康养生",
    categorySlug: "jiankang-yangsheng",
    date: "2026-07-02",
    readCount: 21980,
    commentCount: 678,
    author: "养生达人",
    imageSeq: "hot-article-01",
  },
  {
    id: "article-10",
    title: "娱乐八卦板块：2026年上半年热门影视剧大盘点",
    excerpt: "从国产剧到海外大片，从综艺节目到纪录片，娱乐八卦板块的用户们评选出了2026年上半年最值得观看的影视作品。",
    content: "2026年上半年，影视圈精彩纷呈。爱情岛论坛娱乐八卦板块的用户们用投票和讨论选出了最受欢迎的作品。\n\n国产剧方面：古装剧持续霸屏，现代都市剧也在题材和制作上不断创新突破，多部作品引发全网热议。\n\n海外剧集：韩剧、美剧、日剧各有佳作，悬疑烧脑和温情治愈两大类型最受社区用户青睐。\n\n综艺节目：音乐竞演、旅行真人秀、谈话类节目形式多样，满足了不同观众的娱乐需求。\n\n电影市场：春节档和五一档票房竞争激烈，国产动画电影表现亮眼，进口大片同样精彩纷呈。\n\n如果你也是影视爱好者，欢迎在娱乐八卦板块分享你的观剧心得，和社区小伙伴一起畅聊！",
    category: "娱乐八卦",
    categorySlug: "yule-bagua",
    date: "2026-06-28",
    readCount: 34200,
    commentCount: 1023,
    author: "影评人小K",
    imageSeq: "hot-article-02",
  },
  {
    id: "article-11",
    title: "生活分享板块：独居生活的100个小确幸",
    excerpt: "独居生活虽然偶有寂寞，但更多的是自由与自在。社区用户集体创作的独居生活小确幸清单，分享那些让平凡日子闪闪发光的瞬间。",
    content: "在爱情岛论坛的生活分享板块中，一条关于「独居生活的小确幸」的帖子引发了数千条回复。我们将这些温暖的分享整理为100个小确幸清单。\n\n周末睡到自然醒，阳光透过窗帘洒在脸上；下厨做一道新学的菜，虽然卖相一般但味道不错；深夜窝在沙发上看一部老电影，不用担心打扰任何人。\n\n养一盆绿植，看着它慢慢长大；整理房间后，坐在整洁的空间里喝一杯热茶；用蓝牙音箱放一首喜欢的歌，在客厅里自由地跳舞。\n\n下雨天不出门，听着雨声看书；偶然发现一家藏在巷子里的咖啡馆；收到远方朋友寄来的明信片；学会了一项新技能，哪怕只是换灯泡这样的小事。\n\n独居不是孤独，而是一种主动选择的生活方式。在这个属于自己的空间里，每一天都可以是诗。",
    category: "生活分享",
    categorySlug: "shenghuo-fenxiang",
    date: "2026-06-20",
    readCount: 45600,
    commentCount: 1890,
    author: "一个人的诗",
    imageSeq: "hot-article-03",
  },
  {
    id: "article-12",
    title: "爱情岛论坛VIP会员值得开通吗？全方位对比分析",
    excerpt: "从价格、功能、使用场景等角度全面对比普通会员与VIP会员的差异，帮助你做出最适合自己的选择。",
    content: "很多用户都在纠结是否开通爱情岛论坛的VIP会员，这里从多个维度为你分析。\n\n价格对比：VIP月卡29元、季卡69元（月均23元）、年卡199元（月均约16.6元）。年卡性价比最高，日均不到6毛钱。\n\n核心权益：去广告浏览、专属身份标识、更大附件上传空间（100MB vs 10MB）、帖子置顶特权、优先客服响应。\n\n进阶权益：专属表情包和主题皮肤、个性域名设置、查看谁访问了你的主页、高级搜索过滤功能。\n\n适合开通的人群：高频使用的活跃用户、内容创作者、希望获得更多曝光的用户、对广告敏感的浏览者。\n\n可以不着急开通的情况：偶尔浏览的低频用户、只浏览不发帖的用户、对现有功能已经满意的用户。\n\n总体来说，如果你每天都会使用爱情岛论坛，年卡VIP是一个性价比不错的选择。",
    category: "使用攻略",
    categorySlug: "shiyong-gonglve",
    date: "2026-06-15",
    readCount: 28500,
    commentCount: 756,
    author: "理性消费菌",
    imageSeq: "hot-article-04",
  },
];

export const getArticlesByCategory = (slug: string): ArticleData[] => {
  return allArticles.filter((a) => a.categorySlug === slug);
};

export const getArticleById = (id: string): ArticleData | undefined => {
  return allArticles.find((a) => a.id === id);
};

export const getRelatedArticles = (article: ArticleData, count: number = 3): ArticleData[] => {
  return allArticles
    .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, count);
};

export const allCategorySlugs = [
  { slug: "qinggan-jiaoliu", name: "情感交流", icon: "ri-heart-line", color: "bg-rose-100 text-rose-700" },
  { slug: "shenghuo-fenxiang", name: "生活分享", icon: "ri-sun-line", color: "bg-amber-100 text-amber-700" },
  { slug: "jishu-taolun", name: "技术讨论", icon: "ri-code-line", color: "bg-emerald-100 text-emerald-700" },
  { slug: "yule-bagua", name: "娱乐八卦", icon: "ri-movie-line", color: "bg-violet-100 text-violet-700" },
  { slug: "meishi-lvyou", name: "美食旅游", icon: "ri-cup-line", color: "bg-orange-100 text-orange-700" },
  { slug: "jiankang-yangsheng", name: "健康养生", icon: "ri-mental-health-line", color: "bg-teal-100 text-teal-700" },
  { slug: "shiyong-gonglve", name: "使用攻略", icon: "ri-guide-line", color: "bg-sky-100 text-sky-700" },
  { slug: "shequ-zhinan", name: "社区指南", icon: "ri-compass-3-line", color: "bg-indigo-100 text-indigo-700" },
  { slug: "pingtai-dongtai", name: "平台动态", icon: "ri-notification-3-line", color: "bg-pink-100 text-pink-700" },
];